import { render } from "./new_dashboard.vue?vue&type=template&id=5d79e578&scoped=true"
import script from "./new_dashboard.vue?vue&type=script&lang=js"
export * from "./new_dashboard.vue?vue&type=script&lang=js"

import "./new_dashboard.vue?vue&type=style&index=0&id=5d79e578&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d79e578"]])

export default __exports__